export default __webpack_public_path__ + "static/media/photo9.53234731.jpg";